/*
 * Copyright (c) 2023
 *
 * The source code and all documents related to the source code ("Material") are owned by
 * Frictionless Systems, LLC.
 *
 * The Material contains trade secrets, proprietary information, and confidential information.
 * No part of the Material may be used, copied, reproduced, modified, published, distributed, or
 * disclosed in any way without Frictionless Systems, LLC’s express prior written permission.
 *
 * The Material may be protected under patent, trademark, copyright, or trade secret laws.  No
 * license is granted to you by disclosure or delivery of the Materials.  Any license must be
 * express and approved by Frictionless Systems, LLC in writing.
 *
 * “Frictionless Systems” and “Impulse” are registered trademarks of Frictionless Systems, LLC.
 */

package systems.frictionless.impulse.browser.viewmodel

import org.w3c.dom.url.URLSearchParams
import systems.frictionless.impulse.browser.routing.Route
import systems.frictionless.impulse.browser.routing.Router
import systems.frictionless.impulse.browser.routing.WindowObjectProxy
import systems.frictionless.impulse.rest.route.RootPath

class RoutingViewModel(windowObjectProxy: WindowObjectProxy) {
    // Note that order is important; router clears the query string so the query string must be retrieved first here.
    // This is global for the lifetime of the application.  The intended use case is to capture the query string from
    // an external link, rather than something used internally.  For internal state passing, we generally rely on our
    // own code  (e.g. ViewModels, passing arguments to methods), rather than anything URL based.
    val initialQueryString = windowObjectProxy.queryString

    private val router =
        Router(
            windowObjectProxy = windowObjectProxy,
            defaultScreen = Route.Wizard,
            initialScreen = Route.fromHash(URLSearchParams(initialQueryString).get(RootPath.QUERY_STRING_KEY_DEEP_LINK_FRAGMENT))
        )

    val state = router.currentPage

    fun changeRoute(route: Route) {
        router.navigate(route)
    }
}

private fun Route.Companion.fromHash(hash: String?): Route {
    Route.values().forEach {
        if (it.hash == hash) {
            return it
        }
    }

    return Route.Wizard
}
